import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M4.10287 3.55825C4.27116 3.21647 4.61904 3 5.00001 3H19C19.381 3 19.7289 3.21647 19.8971 3.55825C20.0654 3.90003 20.0249 4.30775 19.7926 4.60971L15 10.8401V20C15 20.4045 14.7564 20.7691 14.3827 20.9239C14.009 21.0787 13.5789 20.9931 13.2929 20.7071L9.2929 16.7071C9.10536 16.5196 9.00001 16.2652 9.00001 16V10.8401L4.20738 4.60971C3.9751 4.30775 3.93458 3.90003 4.10287 3.55825ZM7.03087 5L10.7926 9.89029C10.9271 10.0651 11 10.2795 11 10.5V15.5858L13 17.5858V10.5C13 10.2795 13.0729 10.0651 13.2074 9.89029L16.9691 5H7.03087Z"
  />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3.18166 3.6539C2.63757 2.95435 3.13609 1.93506 4.02233 1.93506H11.9777C12.8639 1.93506 13.3624 2.95435 12.8183 3.65391L10.065 7.19391V12.793C10.065 13.7418 8.91785 14.2169 8.24694 13.546L6.24694 11.546C6.04721 11.3463 5.93501 11.0754 5.93501 10.793V7.19391L3.18166 3.6539ZM4.15523 3.06506L6.84067 6.51777C6.98607 6.70471 7.06501 6.93478 7.06501 7.17161V10.766L8.93501 12.636V7.17161C8.93501 6.93478 9.01395 6.70471 9.15935 6.51777L11.8448 3.06506H4.15523Z"
  />
);

export const FilterIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Filter" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
